<template>
  <div class="question">
    <div class="answer_title">题目</div>
    <div class="exercises_answer_wrap">
      <div
        v-for="item in attaches"
        :key="item.id"
        class="exercises_answer_img"
        @click="showImg(getCutUrl(item))"
      >
        <VanImage
          height="4.26667rem"
          width="100%"
          fit="cover"
          :src="getCutUrl(item)"
          error-icon="https://img01.yzcdn.cn/upload_files/2021/02/24/Fn8oIfXDagXwmD6spKTDnooOOea-.png"
        />
        <div class="preview">点击可查看全图</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Image } from 'vant'
import { getCutWaterUrl } from '@/static/js/oss'
import { mapState } from 'vuex'
export default {
  components: {
    VanImage: Image
  },
  props: {
    attaches: {
      type: Array,
      default: () => []
    },
    showJiucuo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('answerExplain', ['hasViewExplainRight'])
  },
  mounted() {},
  methods: {
    getOssImgCutUrl(url, attache) {
      return `${this.$env.ossUrl(url)}?x-oss-process=image/crop,x_${parseInt(
        attache.ltx
      )},y_${parseInt(attache.lty)},w_${parseInt(attache.width)},h_${parseInt(attache.height)}`
    },
    getOssPath(url) {
      return url ? this.$env.ossUrl(url) : ''
    },
    getCutUrl(attche) {
      const path = attche.page.blankPicPath
      return getCutWaterUrl(this.getOssImgCutUrl(path, attche))
    },
    showImg(imgpath) {
      window.wx.previewImage({
        current: 'imgpath', // 当前显示图片的http链接
        urls: [imgpath] // 需要预览的图片http链接列表
      })
    }
  }
}
</script>
<style lang="scss">
.question {
  .answer_title {
    padding: 0 16px;
    margin: 15px 0;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
  }
  .explain_content {
    background: #fff;
  }
  .exercises_answer_wrap {
    position: relative;
    padding: 0 16px;
    .exercises_answer_img {
      position: relative;
      border-radius: 6px;
      overflow: hidden;
      margin-bottom: 15px;
      border: 0.5px solid #f3f6f9;
      box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.04);
      .ques_img {
        width: 100%;
      }
      .van-icon__image {
        width: 100%;
        height: auto;
      }
      .preview {
        position: absolute;
        padding: 2px 4px;
        bottom: 10px;
        left: 10px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 23px;
        font-size: 9px !important;
        color: #ffffff;
      }
    }
  }
}
</style>
